// extracted by mini-css-extract-plugin
export default {"table":"Info_table__5x+cP"};